import script from "./ButtonUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonUser.vue?vue&type=script&setup=true&lang=js"

import "./ButtonUser.vue?vue&type=style&index=0&id=70586476&scoped=true&lang=scss"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70586476"]])

export default __exports__